module.exports = __webpack_public_path__ + "img/xiaomi-bonus.88eb8839.jpg";